import api from '../../plugins/api';

const createDeal = (payload) => {
  return api.post('/api/crm/deals/createDeal', { ...payload });
};

export default createDeal;
